// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"da89701d","787":"680c8d4d"}[chunkId] + ".chunk.js";
};